export default __webpack_public_path__ + "static/einhornalone_identity-f9bd45a355428cd8351ca4be3bd94c47.svg";